export default __webpack_public_path__ + "static/eth-ba-879e1dda2a7664ef36178313dc3a7484.svg";